'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactI18next = require('react-i18next');
var alloyInput_module = require('./alloy-input.module.scss.js');

var FieldRequiredIndicator = function (_a) {
    var _b = _a.showOptional, showOptional = _b === void 0 ? false : _b, _c = _a.showRequired, showRequired = _c === void 0 ? false : _c, className = _a.className;
    var t = reactI18next.useTranslation()[0];
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: jsxRuntime.jsxs("span", tslib.__assign({ className: "\n          ".concat(showRequired
                ? "".concat(alloyInput_module.default['field-required-indicator__label'])
                : showOptional
                    ? "ps-2 ".concat(alloyInput_module.default['field-required-indicator__label'])
                    : '', "\n            ").concat(className || '', " ") }, { children: [showRequired && '*', showOptional && t('OPTIONAL')] })) }));
};
var FieldRequiredIndicator$1 = react.memo(FieldRequiredIndicator);

exports.default = FieldRequiredIndicator$1;
//# sourceMappingURL=FieldRequiredIndicator.js.map
